// extracted by mini-css-extract-plugin
module.exports = {"inner":"PlanIcon_inner__cVUDU","icon":"PlanIcon_icon__KX49g","plus":"PlanIcon_plus__WfKHy","pro":"PlanIcon_pro__rJf52","essentials":"PlanIcon_essentials__xUAeW"};